import { render, staticRenderFns } from "./HomeTestimonials.vue?vue&type=template&id=3f9becdc&scoped=true&"
import script from "./HomeTestimonials.vue?vue&type=script&lang=ts&"
export * from "./HomeTestimonials.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTestimonials.vue?vue&type=style&index=0&id=3f9becdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9becdc",
  null
  
)

export default component.exports